import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_URL}/api`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(
  reqConfig => {
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const xCorrelationId = Vue.prototype.$getGuid()
      reqConfig.headers = {
        KingnetAuth: `Cookies ${Vue.prototype.$getCookie('comLoginToken').replace('token=', '')}`,
        'x-requestid': Vue.prototype.$getGuid(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      return reqConfig
    } else {
      Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        router.push({ name: 'LoginMain' })
      })
    }
  },
  err => {
    return Promise.reject(err)
  }
)
instance.interceptors.response.use(
  res => res,
  err => {
    console.log(err.response)
    // eslint-disable-next-line eqeqeq
    if (err && err.response && err.response.status == 400) {
      return Promise.reject(err)
    // eslint-disable-next-line eqeqeq
    } else if (err && err.response && err.response.status == 401 && err.config.url !== '/Arrived/Total' && err.config.url !== '/IdCard') {
      Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 401) { router.push({ name: 'LoginMain' }) } else if (err.response.status == 403) { Vue.prototype.$toMainPage() }
      })
      return Promise.reject(err)
    } else if (err && err.response && err.response.status === 409 || err.response.status === 404) {
      Vue.prototype.$alert(err.response.data.ErrorMessage.Description, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 404) { router.push({ name: 'LoginMain' }) }
      })
      return Promise.reject(err)
    } else {
      return Promise.reject(err)
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/Voting/
export const apiVote = {
  // tab
  Vote: {
    GetVoteList: (requestData, config) => instance.get('/Voting/List', Object.assign({}, { params: requestData }, config)), // 取得投票列表
    ExportVote: (requestData, config) => instance.get('/Voting/Export', Object.assign({}, { params: requestData }, config)), // 匯出投票
    DeleteVote: (requestData, config) => instance.delete(`/Voting/${requestData.VotingId}`, config), // 刪除投票
    NotificationAgain: (requestData, config) => instance.delete('/Voting/NotificationAgain', Object.assign({}, { params: requestData }, config)), // 刪除投票
    UploadFile: (requestData, config) => instance.post('/Voting/UploadFile', requestData, config), // 上傳檔案
    PostVote: (requestData, config) => instance.post('/Voting', requestData, config), // 送出投票
    GetVote: (requestData, config) => instance.get(`/Voting/Detail/${requestData.VotingId}`, config), // 取得投票細節
    PutVote: (requestData, config) => instance.put('/Voting', requestData, config), // 修改投票
    GetOptionVoteRecord: (requestData, config) => instance.get('/Voting/CandidateVotingRecord', Object.assign({}, { params: requestData }, config)), // 取得選項投票紀錄
    GetCommentList: (requestData, config) => instance.get('/Voting/Comments', Object.assign({}, { params: requestData }, config)), // 取得留言列表
    PatchCommentHidden: (requestData, config) => instance.patch('/Voting/VotingCommentHidden', requestData, config), // 變更留言隱藏
    DoneVote: (requestData, config) => instance.patch(`/Voting/VotingDone?votingId=${requestData.votingId}`, config) // 終止投票
  }
}
